import { Check } from "lucide-react";

const STEPS = [
  { id: 1, label: "Select Vehicle" },
  { id: 2, label: "Extras & Insurance" },
  { id: 3, label: "Checkout & Details" },
];

/**
 * WizardSteps (v4.4.8) — editorial 3-step progress bar for the public
 * booking flow. Numbered badges, active step in solid black, completed
 * steps get a checkmark and stay clickable so customers can hop back
 * without losing their dates, car or form entries.
 */
export default function WizardSteps({ current, maxStep, onSelect }) {
  return (
    <nav className="mt-4 flex items-stretch gap-1.5" data-testid="pb-wizard-steps" aria-label="Booking steps">
      {STEPS.map(({ id, label }) => {
        const active = id === current;
        const done = id < current || (id <= maxStep && id !== current);
        const clickable = id <= maxStep;
        return (
          <button
            key={id}
            type="button"
            disabled={!clickable}
            onClick={() => clickable && onSelect(id)}
            data-testid={`pb-wizard-step-${id}`}
            data-state={active ? "active" : done ? "done" : "locked"}
            aria-current={active ? "step" : undefined}
            className={`group flex-1 text-left px-3 py-2 border-t-2 transition-colors ${
              active
                ? "border-neutral-900"
                : clickable
                  ? "border-neutral-300 hover:border-neutral-900 cursor-pointer"
                  : "border-neutral-200 cursor-not-allowed"
            }`}
          >
            <span className="flex items-center gap-2">
              <span
                className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-semibold tabular-nums shrink-0 transition-colors ${
                  active
                    ? "bg-neutral-900 text-white"
                    : done
                      ? "bg-neutral-900/10 text-neutral-900 group-hover:bg-neutral-900 group-hover:text-white"
                      : "bg-neutral-100 text-neutral-400"
                }`}
              >
                {done ? <Check size={11} strokeWidth={3} /> : id}
              </span>
              <span
                className={`text-[11px] md:text-xs tracking-wide uppercase truncate ${
                  active
                    ? "font-bold text-neutral-900"
                    : clickable
                      ? "font-medium text-neutral-600 group-hover:text-neutral-900"
                      : "font-medium text-neutral-400"
                }`}
              >
                {label}
              </span>
            </span>
          </button>
        );
      })}
    </nav>
  );
}
